import { View } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TouchableNoFeedback } from '@flix/common/elements/controls'
import { cursorPointer } from '@flix/common/style/webStyles'

const TouchableContainer = styled(TouchableNoFeedback)`
  ${(props) => props.onPress && cursorPointer};
`

const Background = styled(View)`
  box-shadow: 0 0 10px ${(props) => props.theme.colors.grayLight};
  background: ${(props) => props.theme.colors.foreground};
`

export const BlockGlowing = ({ onLayout, onPress, children, style }) => (
  <TouchableContainer onPress={onPress} style={style}>
    <Background onLayout={onLayout}>{children}</Background>
  </TouchableContainer>
)

BlockGlowing.propTypes = {
  onLayout: PropTypes.func.isRequired,
  onPress: PropTypes.func,
}
